export default "__VITE_ASSET__DvbGbXBF__"